import { Provider } from 'react-redux';
import { AppProps } from 'next/app';

import { wrapper } from './store/createStore';
import baseInitialProps from './baseInitialProps';
import bootstrap from './bootstrap';

bootstrap();

const DomRuApp = ({ Component, ...rest }: AppProps): JSX.Element => {
    const { store, props } = wrapper.useWrappedStore(rest);
    const { pageProps } = props;

    return (
        <Provider store={store}>
            <Component {...pageProps} />
        </Provider>
    );
};

DomRuApp.getInitialProps = baseInitialProps;

export default DomRuApp;
